<template>
    <div>
        <ViewUserRoster  v-if="!!item" @success="alertSuccess"></ViewUserRoster>

        <UserRosterTable
            title="Users"
            @addRoster="showUserRosterModal"
            ref="table"
        >
       
    </UserRosterTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import UserRosterTable from './UserRosterTable'
import ViewUserRoster from './ViewUserRoster'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'UserRoster',
    mixins: [popupMixins, permissionsMixins],
    components: {
        UserRosterTable,
        ViewUserRoster,
        
    },
    data: () => {
        return {
            item: null,
          
        }
    },
    async mounted(){
        await this.$store.dispatch('user_roster/fetchUsers');
    },
    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showUserRosterModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
      
    },
}
</script>
<style></style>
